import React from 'react';
import { Product, Variant } from '../../models';
import { getPosibleOptions } from '../../lib';

interface VariantOptionsProps {
  product: Product;
  selectedVariant: Variant;
  setSelectedVariant: (variant: Variant) => void;
}

function VariantOptions({
  product,
  selectedVariant,
  setSelectedVariant,
}: VariantOptionsProps) {
  return (
    <div className="w-full flex flex-row overflow-auto gap-2 pb-1">
      {getPosibleOptions(product)?.map((option) => (
        <button
          key={option?.variant?._id}
          onClick={() => {
            setSelectedVariant(option?.variant);
          }}
          onMouseOver={() => {
            setSelectedVariant(option?.variant);
          }}
          onFocus={() => {
            setSelectedVariant(option?.variant);
          }}
          type="button"
          className={`h-full flex-shrink-0 w-fit ease-in-out rounded-sm duration-150 border px-2 text-sm text-center flex justify-center items-center text-purple-200  cursor-pointer ${
            selectedVariant?._id === option?.variant?._id
              ? 'bg-purple-50 border-purple-100'
              : 'hover:bg-system-300 border-system-400'
          }`}
        >
          {option?.value}
        </button>
      ))}
    </div>
  );
}

export default VariantOptions;
